var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { memo, useEffect, useMemo, useState } from "react";
import { Card } from "../../tremor/Card";
import ChartCard from "../Chart/ChartCard";
import { Button } from "../../tremor/Button";
import { useDashboard } from "../../layouts/Dashboard/useDashboard";
import { useBackend } from "../../layouts/Wrapper";
import { toast } from "sonner";
import { Text, Title } from "../../tremor/Text";
import { ArrowRightIcon, XMarkIcon } from "@heroicons/react/16/solid";
import { ChartPlaceholder } from "../ChartLoader";
import { Badge } from "../../tremor/Badge";
const WidgetLibraryRaw = ({ onExpanded, onClose }) => {
    const { backend, adminMode } = useBackend();
    const { dashboard, refreshWidgets } = useDashboard();
    const [library, setLibrary] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [loading, setLoading] = useState(true);
    const getLibrary = () => __awaiter(void 0, void 0, void 0, function* () {
        setLibrary([]);
        if (!dashboard)
            return;
        setLoading(true);
        let newSuggestions = yield (backend === null || backend === void 0 ? void 0 : backend.widgets.list({
            dashboard: dashboard.id,
            use_in_library: true,
        }));
        if (newSuggestions && newSuggestions.length > 0) {
            setLibrary(newSuggestions);
        }
        setLoading(false);
    });
    useEffect(() => {
        if (dashboard && dashboard.id) {
            getLibrary();
        }
    }, [dashboard === null || dashboard === void 0 ? void 0 : dashboard.id]);
    const removeFromLibrary = (id) => __awaiter(void 0, void 0, void 0, function* () {
        toast.promise(() => __awaiter(void 0, void 0, void 0, function* () {
            return backend === null || backend === void 0 ? void 0 : backend.widgets.delete(id);
        }), {
            loading: "Deleting widget...",
            success: () => {
                getLibrary();
                return "Widget deleted";
            },
            error: (error) => "Error deleting widget: " + error.message,
        });
    });
    const addToDashboard = (wid) => __awaiter(void 0, void 0, void 0, function* () {
        let newObj = Object.assign(Object.assign({}, wid), { use_in_library: false });
        // @ts-ignore
        delete newObj.id;
        if (!backend)
            return;
        toast.promise(() => __awaiter(void 0, void 0, void 0, function* () {
            let wid = yield backend.widgets.create(newObj);
            let data = yield backend.widget(wid.id).updateCache();
            return true;
        }), {
            loading: "Adding widget to dashboard...",
            success: () => {
                refreshWidgets(backend);
                if (onClose)
                    onClose();
                return "Widget added to dashboard";
            },
            error: (error) => "Error adding widget to dashboard: " + error.message,
        });
    });
    const AddToDashboardEnabled = useMemo(() => {
        var _a;
        if (adminMode)
            return true;
        if ((_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _a === void 0 ? void 0 : _a.can_create_widgets)
            return true;
        return false;
    }, [dashboard, adminMode]);
    const filteredLibrary = useMemo(() => {
        if (expanded)
            return library;
        else
            return library.slice(0, 4);
    }, [expanded, library]);
    if (!loading && library.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "onvo-flex onvo-flex-col onvo-w-full" },
        React.createElement("div", { className: "onvo-flex onvo-w-full onvo-pt-2 onvo-pb-2 onvo-flex-row onvo-items-center onvo-justify-between" },
            React.createElement(Title, null, "Library"),
            !loading && filteredLibrary.length > 0 && (React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-items-center" }, expanded ? (React.createElement(Button, { variant: "ghost", onClick: () => {
                    setExpanded(false);
                    onExpanded(false);
                } },
                "View less",
                React.createElement(XMarkIcon, { className: "onvo-size-4 onvo-ml-1" }))) : (React.createElement(Button, { variant: "ghost", onClick: () => {
                    setExpanded(true);
                    onExpanded(true);
                } },
                "View more",
                React.createElement(ArrowRightIcon, { className: "onvo-size-4 onvo-ml-1" })))))),
        loading && (React.createElement("div", { className: "onvo-question-modal-suggestions-list onvo-grid onvo-grid-cols-1 @xl/questionmodal:onvo-grid-cols-2 onvo-gap-2 onvo-w-full" }, [1, 2, 3, 4].map((a) => (React.createElement(ChartPlaceholder, { key: "library-loading-" + a, className: "onvo-h-72" }))))),
        !loading && filteredLibrary.length > 0 && (React.createElement("div", { className: "onvo-question-modal-suggestions-list onvo-grid onvo-grid-cols-1 @xl/questionmodal:onvo-grid-cols-2 onvo-gap-2 onvo-w-full" }, filteredLibrary.map((a) => (React.createElement("div", { className: "!onvo-h-96", key: a.id },
            React.createElement(ChartCard, { widget: a, hideOptions: true, className: "onvo-z-10", footer: React.createElement("div", { className: "onvo-chart-card-dropdown-wrapper onvo-flex-grow onvo-flex-shrink-0 onvo-py-2 onvo-px-2 onvo-z-20 onvo-border-solid onvo-border-t onvo-border-black/5 dark:onvo-border-white/10 onvo-rounded-b-2xl onvo-background-color onvo-flex onvo-w-full onvo-justify-between onvo-flex-row onvo-items-center" },
                    React.createElement("div", { className: "onvo-flex onvo-gap-2 onvo-items-center" }, adminMode && (React.createElement(Button, { variant: "ghost", onClick: () => removeFromLibrary(a.id) }, "Remove from library"))),
                    React.createElement("div", { className: "onvo-flex onvo-gap-2 onvo-items-center" }, AddToDashboardEnabled && (React.createElement(Button, { variant: "secondary", className: "onvo-foreground-color onvo-border-black/10 dark:onvo-border-white/10", onClick: () => addToDashboard(a) }, "Add to dashboard")))) })))))),
        !loading && filteredLibrary.length === 0 && (React.createElement(Card, null,
            React.createElement(Text, null,
                "You have not added any widgets to the library yet. ",
                React.createElement("br", null),
                "You can add widgets to the library by asking a question and clicking on the ",
                React.createElement(Badge, null, "Add to Library"),
                " button")))));
};
export const WidgetLibrary = memo(WidgetLibraryRaw);
//# sourceMappingURL=WidgetLibrary.js.map